import { Main } from '@/components/_common/main';
import { BlogCard } from '@/components/blog-card';
import { getTechWatchPostsServer } from '@lib/blog.server';
import { createFileRoute, ErrorComponent } from '@tanstack/react-router';

const Techwatch = () => {
  const posts = Route.useLoaderData();

  return (
    <>
      <Main className="relative mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {posts.map(elt => ({ ...elt, image: undefined })).map((post) => (
              <BlogCard key={post.slug} post={post} />
            ))}
          </div>

          {posts.length === 0 && (
            <div className="text-center py-12">
              <p className="text-muted-foreground">No posts found.</p>
            </div>
          )}
        </div>
      </Main>
    </>
  );
};

export const Route = createFileRoute('/techwatch')({
  errorComponent: ErrorComponent,
  component: Techwatch,
  loader: async () => {
    return await getTechWatchPostsServer({ data: "veille-tech" });
  },
});
